module.exports = __webpack_public_path__ + "img/faster-incident-response.ded16ae1.svg";